module.exports = __webpack_public_path__ + "assets/img/33_834.64eaf136.jpg";